import { cn } from "@newxsystems/shared";
import { AbyssAction } from "../AbyssAction/AbyssAction";
import { AbyssRichText } from "../AbyssRichText/AbyssRichText";
import type { IAbyssCommonContentProps } from "./AbyssCommonContent.props";

export const AbyssCommonContent = ({
  alignment,
  buttons,
  className,
  description,
  eyebrow,
  heading,
  headingAs = "h2",
  headingClassName,
  tone = "light",
}: IAbyssCommonContentProps) => {
  if (!eyebrow && !heading && !description && !buttons?.length) return null;

  const Heading = headingAs;
  const centered = alignment === "center";
  const actions = buttons;

  return (
    <div
      className={cn(
        "flex max-w-[48rem] flex-col gap-4 md:gap-5",
        centered && "mx-auto items-center text-center",
        className,
      )}
    >
      {eyebrow ? (
        <p
          className={cn(
            "abyss-kicker font-normal",
            tone === "dark" && "text-frost before:bg-frost/55",
          )}
        >
          {eyebrow}
        </p>
      ) : null}
      {heading ? (
        <Heading
          className={cn(
            "abyss-type-section font-abyss-display font-medium text-foreground",
            tone === "dark" && "text-frost",
            headingClassName,
          )}
        >
          {heading}
        </Heading>
      ) : null}
      {description ? (
        <AbyssRichText
          className={cn(
            "max-w-[65ch]",
            tone === "dark" &&
              "text-frost [&_a]:text-frost [&_blockquote]:border-frost/40 [&_blockquote]:text-frost",
          )}
          content={description}
        />
      ) : null}
      {actions?.length ? (
        <div className={cn("flex flex-wrap gap-3 pt-4 md:pt-5", centered && "justify-center")}>
          {actions.map((button, index) => (
            <AbyssAction action={button} key={`${button.href}-${index}`} />
          ))}
        </div>
      ) : null}
    </div>
  );
};

AbyssCommonContent.displayName = "Content::AbyssCommonContent";
